import messages_en from '../translations/en.json';
import messages_ru from '../translations/ru.json';
import { intlConstants } from '../constants/intl';
import { Cookies, isCabinet } from '../utils/utils';

const languages = [
  {
    key: 'en',
    title: 'English (EN)',
  },
  {
    key: 'ru',
    title: 'Русский (RU)',
  },
];

const isLangInList = lang => {
  for (let i = 0; i < languages.length; i++) {
    if (languages[i].key === lang) return lang;
  }
  return null;
};

const getLang = () => {
  if(isCabinet()) {
    return 'ru';
  }
  let lang = Cookies.get('offerrum_lang');
  if (!lang) {
    lang = navigator.language || navigator.userLanguage;

    if (typeof lang === 'string') {
      lang = lang.split('-')[0].toLowerCase();
    }
  }

  return isLangInList(lang) || 'en';
};

const lang = getLang();

const initialState = {
  locale: lang,
  defaultLocale: lang,
  messages: {
    en: messages_en,
    ru: messages_ru,
  },
  languages,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case intlConstants.SET_LOCALE:
      return {
        ...state,
        locale: !isCabinet() ? action.locale : 'ru',
      };
    default:
      return state;
  }
};
